import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_phone_number = _resolveComponent("phone-number")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "auto",
    scrollable: "",
    title: "Отправка 3-х стороннего договора",
    loading: _ctx.is_loading,
    "confirm-button-text": "Отправить",
    "confirm-disabled": _ctx.is_loading,
    onCancel: _ctx.onCancel,
    onConfirm: _ctx.onConfirm
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.state.typeId !== 2)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 0,
              placeholder: "Наименование перевозчика",
              value: _ctx.state.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
              "is-invalid": _ctx.state_form$.name.$error,
              "validation-errors": _ctx.state_form$.name.$errors,
              disabled: _ctx.is_loading
            }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_input, {
          placeholder: _ctx.binPlaceholder,
          value: _ctx.state.bin,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.bin) = $event)),
          "is-invalid": _ctx.state_form$.bin.$error,
          "validation-errors": _ctx.state_form$.bin.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_select, {
          placeholder: "Тип перевозчика",
          options: _ctx.VEHICLE_OWNER_OPTIONS,
          value: _ctx.state.typeId,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.typeId) = $event)),
          "is-invalid": _ctx.state_form$.typeId.$error,
          "validation-errors": _ctx.state_form$.typeId.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["options", "value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: _ctx.namePlaceholder,
          value: _ctx.state.contactName,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.contactName) = $event)),
          "is-invalid": _ctx.state_form$.contactName.$error,
          "validation-errors": _ctx.state_form$.contactName.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Адрес",
          value: _ctx.state.address,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.address) = $event)),
          "is-invalid": _ctx.state_form$.address.$error,
          "validation-errors": _ctx.state_form$.address.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_phone_number, {
          placeholder: "Телефон",
          class: "h-10 mt-2",
          value: _ctx.state.phoneNumber,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
          "is-invalid": _ctx.state_form$.phoneNumber.$error,
          "validation-errors": _ctx.state_form$.phoneNumber.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Почта подписанта",
          value: _ctx.state.contactEmail,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.contactEmail) = $event)),
          "is-invalid": _ctx.state_form$.contactEmail.$error,
          "validation-errors": _ctx.state_form$.contactEmail.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Марка автотранспортного средства",
          value: _ctx.state.carModel,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.carModel) = $event)),
          "is-invalid": _ctx.state_form$.carModel.$error,
          "validation-errors": _ctx.state_form$.carModel.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Шасси/кузов",
          value: _ctx.state.description,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.description) = $event)),
          "is-invalid": _ctx.state_form$.description.$error,
          "validation-errors": _ctx.state_form$.description.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Госномер",
          value: _ctx.state.carNumber,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.carNumber) = $event)),
          "is-invalid": _ctx.state_form$.carNumber.$error,
          "validation-errors": _ctx.state_form$.carNumber.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Цвет",
          value: _ctx.state.carColor,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.carColor) = $event)),
          "is-invalid": _ctx.state_form$.carColor.$error,
          "validation-errors": _ctx.state_form$.carColor.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер техпаспорта",
          value: _ctx.state.techPassport,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.techPassport) = $event)),
          "is-invalid": _ctx.state_form$.techPassport.$error,
          "validation-errors": _ctx.state_form$.techPassport.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Год выпуска",
          value: _ctx.state.releaseDate,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.releaseDate) = $event)),
          type: "number",
          min: "1900",
          max: "2500",
          step: "1",
          "is-invalid": _ctx.state_form$.releaseDate.$error,
          "validation-errors": _ctx.state_form$.releaseDate.$errors,
          disabled: _ctx.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
}